import AbstractItemResource from '../abstract/abstract-item-resource';
import {Resource, Uid} from 'sdk/src/defines';
import {AttributesType} from '../../utility/types';

class State extends AbstractItemResource {
    public resourceType: Resource = Resource.STATES;

    public declare operatorId: Uid;

    public declare type: Resource;

    public declare state: AttributesType;
}

export default State;
